import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { TextBadge, TextTitle4 } from "../Style/new/textStyle";
import { TextLabel, TextNote1, TextPlaceholder, TextTitle2 } from "..";
import defaultImage from "assets/images/white.jpg";
import { colors } from "common/const/colors";
import { InfoIcon } from "../icon";
import { useGlobal } from "common/data/GlobalContext";

// import { ReactComponent as NoticeIcon } from "assets/icons/icon-notifications-24.svg";

const HomeCCCard = ({ item }) => {
  const [clubid, setClubid] = useState(item.id);

  const { globalData, setGlobalData } = useGlobal();

  return (
    <HomeCardLayout
      onClick={() => {
        window.setClub(item.id);
        sessionStorage.setItem("clubId", item.id);
        sessionStorage.setItem("country", item.country);
        sessionStorage.setItem("clubName", item.name);
      }}
      to={"/insights"}
      style={{
        textDecoration: "none",
      }}>
      <CardImageDiv>
        <CardImage
          src={item.imageRef ? item.imageRef : defaultImage}
          alt="club"
        />
      </CardImageDiv>
      <CardText>
        <div
          style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
          <TextTitle2 color={colors.DarkNavy}>{item.name}</TextTitle2>
          <TextPlaceholder color={colors.DarkNavy}>
            {item.country}
          </TextPlaceholder>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "flex-end",
          }}>
          <TextPlaceholder color={colors.LightNavy}>
            {item.roleName}
          </TextPlaceholder>
          {/* <InfoIcon style={{ width: "24px", height: "24px" }} /> */}
        </div>
      </CardText>
    </HomeCardLayout>
  );
};

const HomeCardLayout = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  min-width: 20rem;
  max-width: 27rem;
  width: 100%;
  aspect-ratio: 49 / 40;
  border: none;
  background-color: var(--White);
  border-radius: var(--border-radius-16);
  box-shadow: var(--box-shadow);
`;

const CardImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center;
  box-sizing: border-box;
`;
const CardImageDiv = styled.div`
  width: 100%;
  height: 70%;
  overflow: hidden;
  border-top-left-radius: var(--border-radius-16);
  border-top-right-radius: var(--border-radius-16);
  box-sizing: border-box;
`;

const CardText = styled.div`
  width: 100%;
  height: 30%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  padding: 1rem;
  box-sizing: border-box;
`;

// const CardTitle = styled.div`
//   font-size: var(--font-size-20);
//   font-weight: var(--font-weight-bold);
//   color: var(--DarkNavy);
//   width: 100%;
//   text-overflow: ellipsis;
//   overflow: hidden;
//   white-space: nowrap;
// `;

// const CardContent = styled.div`
//   font-size: var(--font-size-14);
//   font-weight: var(--font-weight-regular);
//   color: var(--DarkNavy);
//   width: 100%;
//   text-overflow: ellipsis;
//   overflow: hidden;
//   white-space: nowrap;
// `;

// const CardSubContent = styled.div`
//   font-size: var(--font-size-14);
//   font-weight: var(--font-weight-regular);
//   color: var(--LightNavy);
//   width: 100%;
//   text-overflow: ellipsis;
//   overflow: hidden;
//   white-space: nowrap;
// `;

// const Notice = styled.div`
//   position: absolute;
//   right: 0;
//   bottom: 0;
//   border: none;
// `;

// const NoticeText = styled.div`
//   font-size: var(--font-size-6);
//   font-weight: var(--font-weight-bold);
//   color: var(--White);

//   background-color: var(--Red);
//   border-radius: 50%;
//   border: 2px solid var(--White);

//   width: 0.8rem;
//   height: 0.8rem;
//   display: flex;
//   justify-content: center;
//   align-items: center;

//   position: absolute;
//   right: -0.4rem;
//   top: -0.1rem;
// `;

export { HomeCCCard };
